module.exports = __webpack_public_path__ + "img/home_logo.697840ee.png";